// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"editOrganizationSubscriptionModal_menuItem__HVx3M","name":"editOrganizationSubscriptionModal_name__23rV2"};